import "core-js/modules/es.array.concat.js";
import { Core } from "@faire/design-tokens";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web/slate/Typography";
import styled, { css } from "styled-components";
var InputScrollOffset = 51;
var SearchResultMaxHeight = 420;
export var scrollToTopIfNeeded = function scrollToTopIfNeeded(itemRef, listRef) {
  var itemTopPosition = itemRef.offsetTop - InputScrollOffset;
  var itemBottomPosition = itemTopPosition + itemRef.clientHeight;
  var minVisibleOffset = listRef.scrollTop;
  var maxVisibleOffset = minVisibleOffset + SearchResultMaxHeight;
  var isScrollNeeded = maxVisibleOffset < itemBottomPosition || minVisibleOffset > itemTopPosition;
  if (isScrollNeeded) {
    var _listRef$scrollTo;
    (_listRef$scrollTo = listRef.scrollTo) === null || _listRef$scrollTo === void 0 ? void 0 : _listRef$scrollTo.call(listRef, 0, itemTopPosition);
  }
};
export var Wrapper = styled.section.withConfig({
  displayName: "SearchFieldstyles__Wrapper"
})(["display:flex;flex-wrap:wrap;justify-content:center;position:relative;background-color:", ";height:", ";margin:", ";width:", ";", "{width:100%;}"], Core.surface.inverse, function (_ref) {
  var mini = _ref.$mini;
  return mini ? "40px" : css(["", "px"], InputScrollOffset);
}, function (_ref2) {
  var mini = _ref2.$mini;
  return mini ? "17px 20px 0 auto" : "0 auto";
}, function (_ref3) {
  var mini = _ref3.$mini,
    expanded = _ref3.$expanded,
    miniInputSize = _ref3.$miniInputSize;
  if (mini) {
    return css(["", "px"], miniInputSize || 340);
  }
  return expanded ? "100%" : "648px";
}, responsiveMediaQueries.mobile);
export var StyledLoadingSpinner = styled(LoadingSpinner).withConfig({
  displayName: "SearchFieldstyles__StyledLoadingSpinner"
})(["position:absolute;right:12px;top:0;bottom:0;margin:auto;z-index:1;"]);
var inputStyle = function inputStyle(mini) {
  return "\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 1px solid ".concat(Core.border.muted, ";\n  border-left: none;\n  border-radius: 0;\n  outline: none;\n  box-shadow: none;\n  line-height: 2;\n  height: 100%;\n  display: block;\n  ").concat(mini ? "\n    width: -webkit-calc(100% - 40px);\n    width: -moz-calc(100% - 40px);\n    width: calc(100% - 40px);\n  " : "\n    width: -webkit-calc(100% - 51px);\n    width: -moz-calc(100% - 51px);\n    width: calc(100% - 51px);\n  ", "\n  ").concat(TypographyStyles({}), "\n  &.placeholder-search-help-center-focused {\n    &::placeholder {\n      color: ").concat(Core.text.subdued, ";\n    }\n  }\n  &::placeholder {\n    color: ").concat(Core.text.subdued, ";\n  }\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    &::placeholder {\n      color: ").concat(Core.text.subdued, ";\n    }\n  }\n  &:focus::placeholder {\n    color: ").concat(Core.text.subdued, ";\n  }\n");
};
export var SearchInput = styled.input.withConfig({
  displayName: "SearchFieldstyles__SearchInput"
})(["", " z-index:1;background-color:transparent;"], function (_ref4) {
  var mini = _ref4.$mini;
  return inputStyle(mini || false);
});
export var IconWrapper = styled.section.withConfig({
  displayName: "SearchFieldstyles__IconWrapper"
})(["display:flex;align-items:center;justify-content:center;width:", ";height:100%;background-color:", ";border:1px solid ", ";border-right:none;"], function (_ref5) {
  var mini = _ref5.$mini;
  return mini ? "40px" : "51px";
}, Core.surface.inverse, Core.border.muted);
export var SearchResult = styled.ul.withConfig({
  displayName: "SearchFieldstyles__SearchResult"
})(["background:", ";width:100%;border:1px solid ", ";border-top:none;z-index:2;text-align:left;overflow-y:auto;max-height:", "px;li{border-bottom:1px solid ", ";a{display:block;padding:", ";&.search-item-selected,&:hover{background:rgba(0,0,0,0.05);}}h2{", "}p{", " em{font-weight:bold;font-style:normal;}}}"], Core.surface.inverse, Core.border.muted, SearchResultMaxHeight, Core.border.muted, getSpacing("3x", "4x"), TypographyStyles({}), TypographyStyles({
  color: Core.text.subdued
}));